import React, { createElement, useMemo, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import AddProduct from "../products-view/add-product/AddProduct";
import { EditProvider } from "../products-view/EditContext";

function ProductViewModal({ show, onHide, data }) {
  console.log("data", data);
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="custom-modal-width"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>{data?.name}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ overflowX: "hidden", padding: 0 }}>
        <EditProvider value={data}>
          <AddProduct />
        </EditProvider>
      </Modal.Body>
    </Modal>
  );
}

export default ProductViewModal;
